<template>
  <div class="declaration-main">
    <div class="left-container">
      <div class="button-section">
        <button @click="resetClicked">Reset</button>
        <button @click="refreshClicked"> Refresh </button>
      </div>

      <div class="separator"></div>
      <div class="date-section">
        <Dropdown placeholder="Company Name" :items="companyNamesItems" itemKey="Co_SName" :selectedObject.sync="filteredsmkMailBoxNo" 
        :errorMessage.sync="smkMailBoxNoError" :isRequired="true" />
      </div>
      <div class="separator"></div>
      <div class="date-section">
        <!-- <div class="date-section"><DateTimePicker  title="Submission Time" :errorMessage.sync="dateError" :value.sync="filteredDate" /></div> -->
        <!-- <div class="date-section"><RemarksBox title="Declaration Time" :freeText="true" :errorMessage.sync="dateError"
      :text.sync="filteredDate"/></div> -->
        <Input :inputValue.sync="filteredDate" :errorMessage.sync="dateError" :isRequired="true" placeholder="Submission Time" />
      </div>
      <div class="separator"></div> 
      <div class="date-section">
      <Input :inputValue.sync="filteredSmkRefNo" :errorMessage.sync="smkRefNoError" :isRequired="true" placeholder="SMK Ref No" />
      <!-- <div class="date-section" style="height: 50%;"><RemarksBox title="SMK Ref No" :freeText="true" :errorMessage.sync="smkRefNoError"
      :text.sync="filteredSmkRefNo"/></div> -->
    </div> 
    </div>
    <div class="right-container">
      <div class="selected-filters">
        <div class="filter-row">
          <div class="filter-title">Company Name</div>
          <div class="colon-separator">:</div>
          <div class="filter-details" v-if="trackingItem.smkMailBoxNo == '9556448083422'">FMG</div>
          <div class="filter-details" v-if="trackingItem.smkMailBoxNo == '9556448026450'">ALC</div>
          <div class="filter-details" v-if="trackingItem.smkMailBoxNo == '9556448092189'">FMGP</div>
          <div class="filter-details" v-if="trackingItem.smkMailBoxNo == '9556448075168'">HW</div>
          <div class="filter-details" v-if="trackingItem.smkMailBoxNo == '9556448111309'">SLF</div>
          <div class="filter-details" v-if="trackingItem.smkMailBoxNo == '9556448073478'">AMKOR</div>
        </div>
        <div class="filter-row">
          <div class="filter-title">Submission Date</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">{{trackingItem.submissionDate ? trackingItem.submissionDate : '' }}</div>
        </div>
        <div class="filter-row">
          <div class="filter-title">SMK Ref No</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{trackingItem.smkRefNo ? trackingItem.smkRefNo : ''}}</div>
      </div>
      <div class="last-refresh">Last Refreshed : {{ lastRefresh }}</div>
      </div>
            <!-- <div class="legend" v-if="responseJobStatus.length > 0">
        <div
          class="legend-item"
          v-for="(l) in legends"
          :key="l"
          :style="{
            border: `3px solid white`,
            backgroundColor: l ? l.color : 'white',
          }"
        >
          {{ l.name }}
        </div>
      </div> -->
      <div class="table-container" >
        <div v-if="responseJobStatus.length == 0">
          {{currentStatus}}
        </div>
        <table v-else>
          <tr>
            <th style="background-color:#ADD8E6;">Date Received</th>
            <th style="background-color:#ADD8E6;">Status Code</th> 
            <th style="background-color:#ADD8E6;">Status Description</th>
            <th style="background-color:#ADD8E6;">SNRF</th>
          </tr>
          <tr v-for="(j, jin) in sorted" :key="jin">
            <td>{{j['jobstatusdt']}}</td>
            <td>{{j['jobstatuscd']}}</td>
            <td>{{j['jobstatusdesc']}}</td>
            <td>{{j['snrf']}}</td>
            <!-- For last item -->
            <!-- <td v-show="!Array.isArray(j['item'])" v-for="(v, vin) in Object.keys(j['item'])" :key="vin">{{ j['item'][v] }} </td> -->
            <!-- For other items
            <td colspan="5" v-show="Array.isArray(j['item'])" style="background-color: white;">
              
              <div class="allSNRFDetails" v-for="(item, iIndex) in j['item']" :key="iIndex">
                <div>{{item['jobstatuscd']}}</div>
                <div> {{item['jobstatusdt']}}</div>
                <div>{{ item['jobstatusdesc'] }}</div>
                <div>SNRF NO: {{ item['snrf'] }}</div>
              </div>
            </td>
            <td v-if="!Array.isArray(j['item'])"><button @click="viewJobDetails(jin)">{{ jobStatusGroup[jin + 1]['show'] ? 'Hide' : 'View' }}</button></td> -->
          </tr>
        </table>
      </div>
    </div>

    <Loader :isVisible="loading" :loadingText="loadText" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      loading: false,
      loadText: '',
      companyNamesItems: [],

      jobDateRange: false,
      openPopup: false,

      legends: [],
      selectedLegend: [],

      filterItems: [
        { title: 'SMK Ref No', value: '' }
      ],

      lastRefresh: '',
      currentStatus: '',

      filteredDate: '',

      filteredsmkMailBoxNo: null,
      filteredSmkRefNo: '',

      smkMailBoxNoError: '',
      dateError: '',
      smkRefNoError: '',

      trackingItem: {},

      responseFromAPI: null,
      responseJobStatus: [],
      jobStatusGroup: [],
      sorted: [],
    }
  },
  props: {
  },
  methods: {
    resetClicked: async function(){
      this.filteredsmkMailBoxNo = null;
      this.filteredDate = '';
      this.filteredSmkRefNo = '';
      this.trackingItem = '';
      this.responseJobStatus = [];
      this.sorted = [];
      this.currentStatus = 'no job status';
    },
    refreshClicked: async function() {
      if(this.isRequiredEmpty()){
        return;
      }
      var toPost = {
        'smkMailBoxNo': this.filteredsmkMailBoxNo ? this.filteredsmkMailBoxNo['SMKMailboxNo'] : '',
        'submissionDate' : this.filteredDate,
        // 'submissionDate': this.$dateTime.getDateTime(this.filteredDate, 'yyyyMMddHHmm') + '00',
        'smkRefNo': this.filteredSmkRefNo,
        // 'smkMailBoxNo': "9556448083422",
        // 'submissionDate': "20210908122716",
        // 'smkRefNo': "K1DB18BF11602109081225AFI21090234",
      };

      console.log(toPost);

      this.loading = true;
      this.loadText = 'Refreshing';

      this.responseFromAPI = await this.$apiCallV2('/SMKMessageTracking/GetTracking', toPost);
      // Get data from api

     if(!this.responseFromAPI['Data']['jobstatus']){
       this.responseJobStatus = '';
      this.trackingItem = toPost;
      this.loading = false;  
      this.currentStatus = this.responseFromAPI['Data']['responseerror']['errdesc'];
        return;
      }

      this.responseFromAPI['Data']['jobstatus'].forEach(r => {
        // 2021-06-21 08:02:11 split
        let dateArray = r['jobstatusdt'].split('');
        dateArray.splice(4, 0, '-'); //2021- (1-4)
        dateArray.splice(7, 0, '-'); //2021-06- (6-7)
        dateArray.splice(10, 0, ' '); //2021-06-21 (9-10)
        dateArray.splice(13, 0, ':'); //2021-06-21 08:(12-13)
        dateArray.splice(16, 0, ':'); //2021-06-21 08:02:(15-16)
        //join together , form new string
        let dateObject = new Date(dateArray.join(''));
        //change the jobstatus description into date format
        r['jobstatusdt'] = this.$dateTime.getDateTime(dateObject, 'yyyy-MM-dd HH:mm:ss');
        // dateString
      });
      
      // Extracting the job status only
      this.responseJobStatus = [];
      this.responseJobStatus = this.responseFromAPI['Data']['jobstatus'];
      this.sorted = [];
      this.sorted = this.responseJobStatus.slice().reverse();
      
      // // // Extracting the unique snrf
      // let snrf = [...new Set(this.responseJobStatus.map(r => r['snrf']))];
      // // Making the status group empty
      // this.jobStatusGroup = [];
      // // Loop through each unique snrf
      // snrf.forEach(s => {
      //   // Get all the objects based on snrf
      //   let currentSNRF = this.responseJobStatus.filter(r => r['snrf'] == s);
      //   // Sort the snrf to be latest on top (index 0)
      //   let sorted = currentSNRF.sort((a,b) => { return parseInt(b['jobstatuscd']) - parseInt(a['jobstatuscd']) });
      //   // Push into status group with last item (to show in the table) and all items (to show at the popup)
      //   // this.jobStatusGroup.push({ lastItem: sorted[0], allItems: sorted, showAll: false });
      //   this.jobStatusGroup.push({ item: sorted[0], show: true});
      //   this.jobStatusGroup.push({ item: sorted, show: false });
      // });
      //}

      this.legends = [ 
        {name: 'In Progress', color: '#FFC000'},
        {name: 'Completed', color: '#A2FF9E'}
       ];
      this.selectedLegend = [];
  

      this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm:ss');
      this.trackingItem = toPost;
      this.loading = false;
    },

    isRequiredEmpty: function() {
      var requiredEmpty = 0;

      if (!this.filteredsmkMailBoxNo) {
        requiredEmpty++;
        this.smkMailBoxNoError = 'Company Name is required!'
      }
      if (!this.filteredDate) {
        requiredEmpty++;
        this.dateError = 'Declaration Time is required!'
      }
      if (!this.filteredSmkRefNo) {
        requiredEmpty++;
        this.smkRefNoError = 'SMK Ref No is required!'
      }

      return requiredEmpty != 0;
    },
    getBackgroundColor: function(statuscd) {
      if (statuscd == '01' || statuscd == '02' || statuscd == '03') {
        return 'yellow';
      } else {
        return 'green';
      }
    },
    getBackgroundClass: function(statuscd) {
      if (statuscd == '01' || statuscd == '02' || statuscd == '03') {
        return 'incomplete';
      } else {
        return 'completed';
      }
    },

    viewJobDetails: async function(index){
      this.jobStatusGroup[index + 1]['show'] = !this.jobStatusGroup[index + 1]['show'];

      // try {
      //   this.loading = true;
      //   this.loadText = "Getting Job Details";
        
      //   this.openPopup = true;
      //   this.loading = false;
      // } catch (e) {
      //   this.loading = false;
      // }
    }
  },
  async mounted() {
    this.loading = true;

    this.loadText = 'Getting Company Names';
    this.companyNamesItems = await this.$apiCallV2('/SMKMessageTracking/GetListMaster?master=SMKMailBox&type=E&module=FMS');

    this.loading = false;
    this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm:ss');

    this.currentStatus = 'no job status';

    let query = this.$route.query;

    if(query['company']){
      var tempCompany = query['company'];
      this.filteredsmkMailBoxNo = this.companyNamesItems.find (a => a['Co_SName'] == tempCompany);
    }
    if (query['submissiontime']) {
      this.filteredDate = query['submissiontime'];
    }
    if (query['smkrefno']) {
      this.filteredSmkRefNo = query['smkrefno'];
    }

    if(query['company'] && query['submissiontime'] && query['smkrefno']){
      this.refreshClicked();
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.declaration-main {
  padding: 5px 45px;
  font-size: 12px;
  display: flex;

  > .left-container {
    height: 100%;
    min-width: 250px;
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    transition: $transition-time;
    overflow: hidden;

    > .button-section {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 105%;

      > button {
        margin-right: 20px;
        font-size: 10px;
        width: 100%;
      }

      > img {
        height: 20px;
        cursor: pointer;
        justify-self: flex-end;
      }
    }

    > .date-section {
      border: 1px solid rgb(200,200,200);
      border-radius: 5px;
      padding: 10px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      > * {
        width: 100%;
      }
    }

    > .filters {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      
      > .filter-items {
        min-width: calc(50% - 10px);
        flex-grow: 1;
        margin: 2px;
        font-size: 10px;
        display: flex;
        flex-direction: column;
        position: relative;

        > .filter-title {
          display: flex;
          align-items: center;
          position: absolute;
          height: 15px;
          width: 100%;

          > div {
            flex-grow: 1;
          }

          > button {
            margin: 0 2px;
            padding: 1px 2px;
          }
        }

        > .filter-details {
          padding: 0 3px;
          height: calc(100% - 20px);
          border: 1px solid rgb(200,200,200);
          margin-top: 2px;
          position: absolute;
          width: 100%;
          top: 16px;
          overflow-y: auto;

          > .item {
            cursor: pointer;
            padding: 2px;

            &:hover {
              background-color: rgba(200,200,200,0.5);
            }
          }

          > .filter-empty {
            background-color: red;
            color: white;
            padding: 5px;
            border-radius: 5px;
            position: absolute;
            left: 3px;
            top: 3px;
            width: calc(100% - 6px);
            cursor: text;
          }
        }

        > textarea {
          position: absolute;
          height: calc(100% - 17px);
          resize: none;
          width: 100%;
          top: 17px;
          border: 1px solid rgb(200,200,200);

          &:focus {
            outline: none;
          }
        }
      }
    }
  }

  > .right-container {
    height: 100%;
    max-width: calc(100% - 250px);
    min-width: calc(100% - 250px);
    // background-color: blue;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    transition: $transition-time;

    > .table-container {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      margin-top: 5px;
      display: flex;
      height: 100%;
      overflow: auto;

      > table {
        width: 100%;
        height: fit-content;
        border-collapse: collapse;

        > tr > th, > tr > td {
          border: 1px solid;
          padding: 5px;
        }

        > tr > td > button {  
          width: 100%;
        }

        > .incomplete {
          background-color: #FFC000;
          
        }

        > .completed {
          background-color: #A2FF9E;
          
        }
      }
    }

    > .selected-filters {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      position: relative;

      > .filter-row {
        width: 100%;
        display: flex;
        padding-bottom: 3px;

        > .filter-title {
          min-width: 110px;
        }

        > .filter-details {
          width: 100%;
          overflow-x: hidden;

          > .details-item {
            overflow-x: hidden;
            text-overflow: ellipsis;
          }

          > .details-dropdown {
            background-color: white;
            position: fixed;
            width: 100%;
            max-width: 250px;
            z-index: 999999;
            overflow-wrap: break-word;
            display: none;

            > .dropdown-content {
              margin-top: 6px;
              padding: 5px;
              border-radius: 5px;
              border: 1px solid rgb(200,200,200);
              box-shadow: 5px 5px 5px rgb(200,200,200);
            }

            > .dropdown-arrow {
              position: absolute;
              bottom: calc(100% - 6px);
              left: 5px;
              border-width: 0 8px 8px 8px;
              border-style: solid;
              border-color: transparent transparent #c8c8c8 transparent;
            }
          }

          &:hover .details-dropdown {
            display: unset;
          }
        }

        > .colon-separator {
          margin-right: 5px;
        }
      }
      
      > .empty-watch-list {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(200,200,200,0.7);
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bolder;
        font-size: 15px;
      }

      > .last-refresh {
        position: absolute;
        top: 5px;
        right: 5px;
      }

      > .close-button {
        position: absolute;
        top: 0;
        left: -25px;
        padding: 5px;
        background-color: white;
        border: 1px solid rgb(150,150,150);
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        > img {
          transition: $transition-time;
        }
      }
    }

    > .legend {
      display: flex;
      background-color: white;
      padding: 5px;
      border-radius: 5px;
      margin: 5px 0;

      > .legend-item {
        margin-right: 5px;
        padding: 2px 10px;
        cursor: pointer;
        border: 1px solid rgb(7, 7, 7);
        user-select: none;
      }
    }

    > .jobs {
      height: 100%;
      overflow: auto;

      > .jobs-row {
        background-color: white;
        padding: 5px;
        margin-bottom: 5px;
        border-radius: 5px;
        display: flex;
        max-height: 85px;
        min-height: 85px;

        > .job-number {
          align-self: center;
          margin: 0 3px;
          min-width: 25px;
          max-width: 25px;
          text-align: right;
        }

        > .jobs-header {
          min-width: 120px;
          max-width: 120px;
          border: 1px solid rgb(200,200,200);
          padding: 3px;
          font-size: 10px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;

          > .billto-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          > .cargo-type {
            position: absolute;
            right: 5px;
            top: 4px;
            font-size: 10px;
          }
        }

        >.image-wrapper{
          position: relative;
          display: flex;
          flex-direction: column;
          align-self: flex-end;

          > img {
            margin: 0 3px;
            border: 1px solid rgb(200,200,200);
            border-radius: 100%;
            cursor: pointer;
            padding: 3px;
            align-self: flex-end;
            margin: 3px;
          }

          > .more-menu {
            position: absolute;
            background-color: rgba(0,0,0,0.9);
            color: white;
            border-radius: 5px;
            bottom: 0px;
            left: calc(100% + 5px);
            z-index: 99;
            width: 150px;

            > .arrow {
              right: 100%;
              bottom: 5px;
              position: absolute;
              border-width: 10px;
              border-style: solid;
              border-color: transparent rgba(0,0,0,0.9) transparent transparent;
            }

            > .show-more-item {
              border-bottom: 1px solid gray;
              padding: 5px;
              cursor: pointer;
              border-radius: 5px;

              &:hover {
                background-color: rgb(118, 118, 118);
              }
            }
          }
        }
        
        > .tas-details {
          overflow: overlay;
          display: flex;
        }
      }
    }
  }

  > .tabulator-popup {
    width: 100%;
    height: calc(100% - 50px);
    position: fixed;
    left: 0;
    top : 50px;
    background-color: rgba(200,200,200,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 255;

    > .popup-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      background-color: white;
      width: 90%;
      height: 90%;
      padding: 10px;

      > .popup-header {
        display: flex;
        align-items: center;

        > .title {
          font-weight: bold;
          font-size: 15px;
          margin: 0 10px;
        }
      }


      > .confirm-cancel-buttton {
        position: relative;
        top: 45px;
        display: flex;

        > button {
          margin: 0 5px;
        }
      }
    }
  }
}

.flip-tas-details {
  transform: rotateY(180deg);
}

.flip-remarks {
  transform: rotateY(360deg) !important;
}

.separator {
  height: 1px;
  width: 100%;
  margin: 3px;
}

.allSNRFDetails {
  border: 2px solid gray;
  border-radius: 5px;
  margin: 5px 0;
  margin-left: 5px;
  padding: 5px;
}
</style>

<style lang="scss">

.jobs-tas {
  min-width: 145px;
  max-width: 145px;
  margin-right: 3px;
  border: 1px solid rgb(200,200,200);
  font-size: 10px;
  position: relative;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: none;
}

.show-tas {
  display: flex;

  >#details-wrap{
    width:100%;
    align-self: flex-end;
    position: absolute;
    right: 0;
    text-align: right;

    >#attImg{
    width:20px;
    position: relative;
    height:20px;
    border: 1px solid #d8d8d8;
    border-radius: 100%;
    cursor: pointer;
    padding: 3px;
    margin:2px;
    position: relative;
    background: #fff
    }

    >.remarks-icon{
    cursor:pointer;
    margin:2px;
    }
  }
}

//attachment popup
.attchWin-main{
width: calc(100%);
height: calc(100% - 10px);
padding: 5px;
position: absolute;
top: 0;
left: 0;
bottom: 0;
display: -webkit-box;
display: -ms-flexbox;
display: flex;
align-items: center;
background-color: #00000048;
z-index: 255;

  >.attchWin-close{
    height: 30px;
    width: 30px;
    font-weight: bold;
    border-radius: 50%;
    background-color: white;
    color: black;
    text-align: center;
    cursor: pointer;
    position: absolute;
    right: 0;
    top:0;
    margin: 20px;
    font-size: 14px;
      }

  >.attchWin-display{
    
    width: 80%;
    margin: 0 auto;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #eaeaea;
    border-radius: 3px;
    display:flex;
    height:90vh;

    

    >.left{
    position: relative;
    float: left;
    width: 100%;
    height: 100%;
    border: 1px solid black;
    background: black;
    height:100%;
    text-align: center;
    display: flex;

    >.leftButton{

      width:auto;
      height:100%;
      float:left;
      align-items: center;
      left:0;

      >.navButton-left{
      margin: 0 auot;
      position: relative;
      z-index: 300;
      font-size: 36px;
      color: white;
      background: none;
      top:50%;

        &:hover{
          cursor: pointer;
          background: rgba(200,200,200,0.8);
        }

      }
      
    }

    >.rightButton{

      width:auto;
      height:100%;
      float:right;
      align-items: center;
      
      >.navButton-right{
      margin: 0;
      position: relative;
      top: 50%;
      float: right;
      /* -webkit-transform: translateY(-50%);
      transform: translateY(-50%); */
      z-index: 300;
      font-size: 36px;
      color: white;
      background: none;

        &:hover{
        cursor: pointer;
        background: rgba(200,200,200,0.8);
        }

      }
      
    }

    

      >.attchWin-attachment{
        position: relative;
        margin: 0 auto;
        width: 80%;
        text-align: center;
        -o-object-fit: contain;
        object-fit: contain;
        float:left;
        align-self: center;
        //top: 25%;

        
        img{
          width: 70%;
          object-fit: contain;
          margin: 0 auto;
          max-height: 90vh;
        }

        &:hover{
            cursor:pointer;
          }

        iframe{
        width: 100%;
        height: 100%;
        min-height: 600px;
        }

      }
    }

    >.right{
    //position: relative;
    float: left;
    width: 500px;
    height: 100%;
    min-width: 250px;
    border: 1px solid black;
    display: grid;

      >.attchWin-info{
        position: relative;
        margin: auto 5px 0;
        text-align: left;
        margin:5px;
        height: fit-content;
        overflow-x: auto;
        

        #infoHeader{
          width: 100%;
          table-layout: fixed;
          font-size: 12px;
          border-collapse: collapse;
          background: #d4dfeb;
          margin: 5px 0px;
          border:1px solid black;

          td{
          padding: 3px;
          }
          th{
            font-weight: bold;
            width: 92px;
            
          }
        }

        #tableContent{
          width: 100%;
          position: relative;
          table-layout: fixed;
          font-size: 12px;
          border-collapse: collapse;
          margin: 20px auto;
          background: #fff;
          align-self: center;
          text-align: left;
          

          tr{
            border: 1px solid black;
            padding: 3px;
            
          }td{
          padding: 3px;
          border: 1px solid black;
          overflow-x: auto;
          }
          th{
            font-weight: bold;
            background: #d4dfeb;
            border: 1px solid black;
            padding: 3px;
            width: 97px;
            
          }
        }               

      }
      >.count{
        position: relative;
        width: auto;
        text-align: center;
        margin: auto 3px 0;
        height: fit-content;
        border: 1px solid black;
        background: #a1a9b2;
        }

    }

  }
textarea {
  height: 100%;
  width: 100%;
  resize: none;
  overflow-y: auto;
  border: 1px solid rgb(200,200,200);
  border-radius: 3px;
}

textarea:focus {
  outline: none;
}

textarea:disabled {
  opacity: 0.8;
  background: rgba(200,200,200,0.3);
}

.top-bar {
  display: flex;
  width: 100%;

  .title {
    flex-grow: 1;
  }
}

}
</style>